import { Table, Button, Popup, List, Checkbox, Text } from '@wework/dieter-ui'
import currencyFormatter from 'currency-formatter'
import React, { useState } from 'react'

import { LightQuality, ViewQuality } from '../SidebarBlocks/SpaceAttributes'
import BulkEditFooter from './BulkEditFooter'

const returnCurrency = spaces => {
  var result = null
  spaces.some(function(space, i) {
    if (space.reservable && space.reservable.currency) {
      result = space.reservable.currency
    }
  })
  return result
}

const getSeatCount = space => {
  let seatCount = 0
  if (space.roomType == 'DEDICATED DESK') {
    seatCount = space.metrics?.desks
  } else {
    if (space.inventoryData?.relationships.length > 0) {
      seatCount = space.inventoryData?.relationships[0]?.seat_count
    }
  }
  return seatCount
}

function SelectedSpaces({ spaces, onHoldHandler, spaceSetter, onShrink }: any) {
  const [attributes, setAttributes] = useState([
    { label: 'Type', value: true },
    { label: 'Seats', value: true },
    { label: 'Capacity', value: true },
    { label: 'Price', value: true },
    { label: 'Size', value: true },
    { label: 'Internal room', value: false },
    { label: 'Windows', value: false },
    { label: 'View quality', value: false },
    { label: 'Light quality', value: false },
    { label: 'Internal obstruction', value: false },
    { label: 'Solid wall', value: false },
  ])
  const updateFieldChanged = index => (e, { checked }) => {
    let newArr = [...attributes]
    newArr[index].value = checked
    setAttributes(newArr)
  }
  const checkedFieldsCount = attributes.filter(att => att.value === true).length
  const totalDesks = spaces.reduce((a, b) => a + (getSeatCount(b) || 0), 0)
  const totalCapacity = spaces.reduce(
    (a, b) => a + (b.reservable?.workUnits || 0),
    0
  )
  const totalPrice = currencyFormatter.format(
    spaces.reduce((a, b) => a + (b.reservable?.price || 0), 0),
    {
      code: returnCurrency(spaces),
    }
  )

  const totalSize = spaces.reduce((a, b) => a + (b.metrics?.sf || 0), 0)

  return (
    <>
      <div style={{ flexGrow: 1, overflow: 'auto', minHeight: '2em' }}>
        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Popup
            openOnTriggerClick
            trigger={
              <Button basic circular size="tiny">
                Showing {checkedFieldsCount} Attributes
              </Button>
            }
            on="click"
            content={
              <Popup.Content>
                <List>
                  {attributes.map((attribute, index) => {
                    return (
                      <List.Item key={index}>
                        <List.Content>
                          <Checkbox
                            //@ts-ignore
                            onChange={updateFieldChanged(index)}
                            label={attribute.label}
                            checked={attribute.value}
                          />
                        </List.Content>
                      </List.Item>
                    )
                  })}
                </List>
              </Popup.Content>
            }
            header="Space attributes"
            basic
          />
          <Text
            size="tiny"
            primary
            style={{ cursor: 'pointer' }}
            onClick={() => {
              onShrink()
              spaceSetter([])
            }}
          >
            Deselect all {spaces.length} spaces
          </Text>
        </div>
        <Table singleLine className="unbordered-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Number</Table.HeaderCell>
              {attributes.map((attribute, index) => {
                if (attribute.value) {
                  return (
                    <Table.HeaderCell key={index}>
                      {attribute.label}
                    </Table.HeaderCell>
                  )
                }
                return null
              })}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {spaces.map((space, index) => {
              if (space.roomType === 'CHAIR' || space.subType === 'CHAIR') {
                return <> </>
              } else {
                return (
                  <Table.Row key={index}>
                    <Table.Cell>{space.number}</Table.Cell>
                    {attributes[0].value && (
                      <Table.Cell>{space.subType}</Table.Cell>
                    )}
                    {attributes[1].value && (
                      <Table.Cell>
                        {space.roomType === 'DEDICATED DESK'
                          ? space.metrics?.desks
                          : space.inventoryData?.relationships.length > 0
                          ? space.inventoryData?.relationships[0]?.seat_count
                          : 0}
                      </Table.Cell>
                    )}
                    {attributes[2].value && (
                      <Table.Cell>{space.reservable?.workUnits}</Table.Cell>
                    )}
                    {attributes[3].value && (
                      <Table.Cell>{space.reservable?.displayPrice}</Table.Cell>
                    )}
                    {attributes[4].value && (
                      <Table.Cell>
                        {space.metrics?.sf.toFixed(2)} ft²
                      </Table.Cell>
                    )}
                    {attributes[5].value && (
                      <Table.Cell>{space.metrics?.internalRooms}</Table.Cell>
                    )}
                    {attributes[6].value && (
                      <Table.Cell>
                        {space.inventoryData?.has_window?.toString()}
                      </Table.Cell>
                    )}
                    {attributes[7].value && (
                      <Table.Cell>
                        {ViewQuality[space.inventoryData?.view_quality]}
                      </Table.Cell>
                    )}
                    {attributes[8].value && (
                      <Table.Cell>
                        {LightQuality[space.inventoryData?.light_quality]}
                      </Table.Cell>
                    )}
                    {attributes[9].value && (
                      <Table.Cell>
                        {space.inventoryData?.obstructions}
                      </Table.Cell>
                    )}
                    {attributes[10].value && (
                      <Table.Cell>
                        {space.inventoryData?.has_solid_wall?.toString()}
                      </Table.Cell>
                    )}
                  </Table.Row>
                )
              }
            })}
          </Table.Body>
          <Table.Header>
            <Table.Row>
              {/* {attributes.leng} */}
              <Table.HeaderCell>Total (STATIC ROW)</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
              {attributes[1].value && (
                <Table.HeaderCell>{totalDesks}</Table.HeaderCell>
              )}
              {attributes[2].value && (
                <Table.HeaderCell>{totalCapacity}</Table.HeaderCell>
              )}
              {attributes[3].value && (
                <Table.HeaderCell>{totalPrice}</Table.HeaderCell>
              )}
              {attributes[4].value && (
                <Table.HeaderCell>{totalSize.toFixed(2)} ft²</Table.HeaderCell>
              )}
              {attributes[5].value && <Table.HeaderCell></Table.HeaderCell>}
              {attributes[6].value && <Table.HeaderCell></Table.HeaderCell>}
              {attributes[7].value && <Table.HeaderCell></Table.HeaderCell>}
              {attributes[8].value && <Table.HeaderCell></Table.HeaderCell>}
              {attributes[9].value && <Table.HeaderCell></Table.HeaderCell>}
              {attributes[10].value && <Table.HeaderCell></Table.HeaderCell>}
            </Table.Row>
          </Table.Header>
        </Table>
      </div>
      <BulkEditFooter onHoldHandler={onHoldHandler} />
    </>
  )
}

export default SelectedSpaces
